import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_product_details: { message: "idle" },
};

export const tenant_update_product_details_Slice = createSlice({
 name: "tenant_update_product_details",
 initialState,
 reducers: {
  success_tenant_update_product_details: (state, action) => {
   state.tenant_update_product_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_product_details: (state, action) => {
   state.tenant_update_product_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_product_details: (state) => {
   state.tenant_update_product_details = { status: app_consts.IDLE };
  },
  loading_tenant_update_product_details: (state) => {
   state.tenant_update_product_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_product_details, fail_tenant_update_product_details, reset_tenant_update_product_details, loading_tenant_update_product_details } = tenant_update_product_details_Slice.actions;

export default tenant_update_product_details_Slice.reducer;